import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { setUserData } from "../services/auth";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const API_URL = `${process.env.REACT_APP_API_URL}/api/auth/login`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(`${API_URL}`, {
      username,
      password,
    });

    const { token, role, nombre, apellido, rut, email, telefono, direccion, comuna, ciudad } = res.data;

    localStorage.setItem("token", token);
    localStorage.setItem("role", role);

    if (role === "CLIENT") {
      setUserData({ nombre, apellido, rut, email, telefono, direccion, comuna, ciudad });
    }

    if (role === "ADMIN") {
      navigate("/admin"); // ruta protegida para administración
    } else {
      navigate("/"); // ruta normal para clientes
    }

    } catch (err) {
      setError("Credenciales inválidas");
    }
  };

  return (
    <div className="login-container">
      <h2>Iniciar Sesión</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Usuario:</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Contraseña:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit">Ingresar</button>
      </form>

      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
}

export default Login;